import React, { useState } from "react";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { AudienceType, useLSSearch } from "./LSSearch";
import { useLanguage } from "@tlc/ls2pac/components/Language";

interface AudienceListItemButtonProps {
  value: AudienceType;
  label: string;
  onClose: () => void;
}
const AudienceListItemButton = ({
  value,
  label,
  onClose,
}: AudienceListItemButtonProps) => {
  const {
    searchParams: { audience },
    setAudienceFilter,
    clearAudienceFilter,
  } = useLSSearch();

  const handleClickAudience = (type: AudienceType) => {
    if (!type) {
      clearAudienceFilter();
    } else {
      setAudienceFilter(type);
    }
    onClose();
  };

  return (
    <ListItemButton dense={true} onClick={() => handleClickAudience(value)}>
      <Radio
        edge="start"
        checked={value === audience}
        tabIndex={-1}
        disableRipple
      />
      <ListItemText primary={label} />
    </ListItemButton>
  );
};

export const AudienceFilter = () => {
  const {
    searchParams: { audience },
  } = useLSSearch();
  const { translate } = useLanguage();
  const [open, setOpen] = useState<boolean>(false);

  const getLabel = (audience: AudienceType) => {
    if (audience === AudienceType.AdultGeneral) {
      return translate("audienceAdult");
    }

    if (audience === AudienceType.Juvenile) {
      return translate("audienceJuvenile");
    }

    return translate("audienceAll");
  };

  const handleClick = async () => {
    setOpen(!open);
  };

  return (
    <>
      <ListItemButton sx={{ gap: 2 }} onClick={handleClick} divider={!open}>
        <ListItemText
          sx={{ my: 0 }}
          primary={translate("audience")}
          secondaryTypographyProps={{ color: "secondary" }}
          secondary={getLabel(audience)}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding dense={true}>
          {Object.values(AudienceType).map((value) => {
            const label = getLabel(value);
            return (
              <AudienceListItemButton
                key={label}
                label={label}
                value={value}
                onClose={() => setOpen(false)}
              />
            );
          })}
        </List>
      </Collapse>
    </>
  );
};
